/**
 * Operator login (ported from CC `Login.tsx`). Cookie JWT via
 * POST /api/v1/auth/login; on success the ["auth","me"] query is
 * invalidated and `RootGate` (router.tsx) swaps in the full shell.
 */
import { useState } from "react";
import {
  Button, Center, Image, Paper, PasswordInput, Stack, TextInput,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";

import logo from "../../../assets/gMVP_mark.png";
import { useLogin } from "../../hooks/useAuth";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const login = useLogin();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login.mutateAsync({ email, password });
    } catch {
      notifications.show({
        color: "red",
        title: "Login failed",
        message: "Check your email and password.",
      });
    }
  };

  return (
    <Center h="88vh">
      <Stack align="center" gap="md" w="100%" px="md">
        <Image src={logo} alt="gMVP" w={200} h={200} fit="contain" style={{ filter: "drop-shadow(0 6px 14px rgba(0, 0, 0, 0.45))" }} />
        <span
          style={{
            fontFamily: "'Sixtyfour', monospace",
            fontSize: 42,
            fontWeight: 400,
            color: "light-dark(var(--mantine-color-teal-6), var(--mantine-color-teal-3))",
            lineHeight: 1,
          }}
        >
          gMVP
        </span>
        <Paper w="100%" maw={380} p="xl" radius="md" withBorder>
          <form onSubmit={(e) => void handleLogin(e)}>
            <Stack>
              <TextInput
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.currentTarget.value)}
                required
              />
              <PasswordInput
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
                required
              />
              <Button type="submit" loading={login.isPending} fullWidth mt="xs">
                Sign in
              </Button>
            </Stack>
          </form>
        </Paper>
      </Stack>
    </Center>
  );
}
